import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import FlatButton from "material-ui/FlatButton";
import FileDownload from "material-ui/svg-icons/file/file-download";
import { RestApiDownloadActiations, API_REPORT } from "../restClient";

const styles = {
  floating: {
    margin: 0,
    top: "auto",
    right: 20,
    bottom: 20,
    left: "auto",
    position: "fixed"
  },
  flat: {
    overflow: "inherit"
  }
};

class DownloadCsvButton extends Component {
  getCsvFile() {
    const { filterValues } = this.props;
    let from = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    let to = moment()
      .endOf("month")
      .format("YYYY-MM-DD");

    if (filterValues.to && filterValues.from) {
      to = moment(filterValues.to).format("YYYY-MM-DD");
      from = moment(filterValues.from).format("YYYY-MM-DD");
    }
    const params = "to=" + to + "&from=" + from;
    RestApiDownloadActiations(params)
      .then(response => response.json())
      .then(item => {
        if (item && item.url) {
          this.downloadfile(item.url);
        }
      })
      .catch(e => {
        console.log(e);
      });
  }
  downloadfile = url => {
    let tempLink = document.createElement("a");
    tempLink.style.display = "none";
    // "http://api.staging.ola.id"
    tempLink.href = API_REPORT + url;
    let resfile = url.lastIndexOf("/") + 1;
    let newfileName = url.substring(resfile, url.length);
    tempLink.setAttribute("download", newfileName);
    // Safari thinks _blank anchor are pop ups. We only want to set _blank
    // target if the browser does not support the HTML5 download attribute.
    // This allows you to download files in desktop safari if pop up blocking
    // is enabled.
    if (typeof tempLink.download === "undefined") {
      tempLink.setAttribute("target", "_blank");
    }
    document.body.appendChild(tempLink);
    tempLink.click();
    document.body.removeChild(tempLink);
  };
  render() {
    // console.log(this.props);
    return (
      <FlatButton
        primary
        label="Download"
        onClick={this.getCsvFile.bind(this)}
        icon={<FileDownload />}
        style={styles.flat}
      />
    );
  }
}

DownloadCsvButton.propTypes = {
  basePath: PropTypes.string,
  filterValues: PropTypes.object
};

export default DownloadCsvButton;



// WEBPACK FOOTER //
// ./src/activations/DownloadCsvButton.js